<template>
    <div class="w-96 max-w-full pl-2 pr-2">
        <img src="/images/brand_logos.png" class="w-full"
             alt="Visa, MasterCard, JCB, AMEX, DinersClub">
    </div>
</template>

<script>
export default {
    name: "BrandLogos"
}
</script>

<style scoped>

</style>
